module.exports = __webpack_public_path__ + "img/2020-min.b42dd308.jpg";